const FormLabel = {
  baseStyle: {
    fontWeight: 'bold',
    mb: 1,
    fontSize: 'sm',
  },
};

export default FormLabel;
